<template>
  <div class="all-box">
      <div class="lunbo-box">
          <el-carousel :interval="5000"  arrow="always" loop >
            <el-carousel-item v-for="(item, index) in image" :key="index" @click.native="clickJumpLunbo(item)">
              <img :src="item.image" fetchpriority="high" loading="eager" alt="" />
            </el-carousel-item>
          </el-carousel>
      </div>

      <div class="box-1">
        <div class="sub-title">钉钉智能协同办公平台</div>
        <div class="title-txt">钉钉已成功服务超过27.000.000家企业</div>
      </div>

      <div class="box-2">
        <div class="top-box">
          <div v-for="(item,idx) in box2List" :index="idx" class="btn-box" @click="handleBtn(idx)">
            <div v-show="item.active" :class="item.classN" v-lazy:background-image="item.activeBg"></div>
            <div v-show="!item.active" class="btn">{{item.title}}</div>
          </div>
        </div>
        <div class="bottom-box">
          <video id="videoBox" style="width: 56rem;height: 42rem;position: absolute;right: 9%;top:4%" @click="clickControls1"  :controls="controls1" :poster="box2List[activeModal].videoImg" v-lazy:poster="box2List[activeModal].videoImg">
            <source id="videoSource" :src="currentVideoSrc" type="video/mp4" />Your browser doesn't support HTML5 video tag.
          </video>
          <div class="left-box">
            <p class="title">{{box2List[activeModal].title}}</p>
            <div class="text">{{box2List[activeModal].text}}</div>

            <div class="flex">
              <div class="btn1" @click="jumpspart(box2List[activeModal].url)">查看详情</div>
              <div class="btn2"  @click="clickJumpLunbo()">售前咨询</div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-3">
        <div class="sub-title">定制化解决方案，为万千企业量身打造</div>
        <div class="title-txt">通过阿里巴巴团队自研最新的低代码平台，为企业构建一站式应用的解决方案，结合AI人工智能，让低代码直接生产AI原生应用</div>
      </div>

      <div class="box-4">
        <div class="top-box">
          <div v-for="(item,index) in box4List" :index="index" class="btn-box" @click="handleBtn4(index)">
            <div v-show="item.active" :class="item.classN"  v-lazy:background-image="item.activeBg"></div>
            <div v-show="!item.active" :class="item.classN2" v-lazy:background-image="item.normalBg"></div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="left-box">
            <p class="title">{{box4List[activeModal4].title}}</p>
            <div class="text">{{box4List[activeModal4].text1}}</div>
            <div class="text">{{box4List[activeModal4].text2}}</div>
            <div class="text">{{box4List[activeModal4].text3}}</div>
            <div class="flex">
              <div class="btn1" @click="jumpspart(box4List[activeModal4].url)">查看详情</div>
              <div class="btn2" @click="clickJumpLunbo()">售前咨询</div>
            </div>
          </div>
          <img alt="" v-show="activeModal4 == 0" v-lazy="box4List[activeModal4].img" style="width:70rem;height:45rem;position: absolute;right: 7%;top:8%">
          <img alt="" v-show="activeModal4 == 1" v-lazy="box4List[activeModal4].img" style="width:75rem;height:30rem;position: absolute;right: 7%;top:20%">
          <img alt="" v-show="activeModal4 == 2" v-lazy="box4List[activeModal4].img" style="width:70rem;height:40rem;position: absolute;right: 7%;top:8%">
        </div>
      </div>

      <div class="box-3">
      <div class="sub-title">钉钉应用中心</div>
      <div class="title-txt">1000+精选应用及企业服务，深度满足各业务场景数字化需求</div>
    </div>

      <div class="box-5">
        <div class="left-box" v-lazy:background-image="box5LeftBg"></div>
        <div class="carousel-container">
          <div class="carousel-wrapper" ref="carouselWrapper">
            <img v-lazy="lbImgSrc" alt="应用中心轮播" />
          </div>
        </div>
      </div>

      <div class="box-3-1">
        <div class="sub-title">提供上门服务，响应企业需求</div>
      </div>

      <div class="box-10">
       <div class="title-box">
         <div class="title">为您提供多种类型的本地化和深度服务</div>
         <div class="title">助力企业更快更好的用钉钉建设企业数智化</div>
       </div>
        <img v-lazy="box10Img"  class="box-10Img"  alt="" >
        <div class="btn-flex">
          <div class="btn1" @click="clickJumpLunbo">立即咨询</div>
          <div class="btn2" @click="clickSM">预约上门服务</div>
        </div>
      </div>

      <div class="box-3">
        <div class="sub-title">沉淀2300万企业组织数字化核心场景</div>
        <div class="title-txt">行业解决方案 >></div>
      </div>

      <div class="box-7">
        <div class="carousel-container swiper">
          <div class="carousel-wrapper swiper-wrapper" ref="carouselWrapper">
            <div v-for="(item, index) in slideList" :key="index" class="slide-item swiper-slide"
                 @mouseenter="handleMouseEnter(index)"
                 @mouseleave="handleMouseLeave(index)">
              <div  v-show="!isHovered[index]">
                <img v-lazy="item.imgUrl" class="img-css" alt="" >
                <div class="title">{{ item.title }}</div>
                <div class="sub-title">{{ item.desc }}</div>
                <div class="link">了解详情 ></div>
              </div>
                <img @click="clickJumpLunbo()" v-show="isHovered[index]" v-lazy="item.imgUrl2" style="width: 100%;height: 100%" alt="" >
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>

      <div class="box-3">
        <div class="sub-title">合作伙伴</div>
        <div class="title-txt">钉钉已服务的企业</div>
      </div>

      <div class="box-8">
        <img v-for="img in box8"  v-lazy="img" class="img-css" alt=""  @click="jumpcustomerCase">
      </div>

      <div class="box-9">
      <div class="cneter-hot">
        <div class="main-hot">
          <vue-seamless-scroll :data="newsList1" :class-option="optionLeft1" class="seamless-warp2">
            <ul class="item">
              <li v-for="(item,index) in newsList1" :key="index">
                <img v-lazy="item" class="img-lunbo" alt="" >
              </li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll :data="newsList2" :class-option="optionLeft2" class="seamless-warp2">
            <ul class="item">
              <li v-for="(item,index) in newsList2" :key="index">
                <img v-lazy="item" alt="" class="img-lunbo" alt="" >
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>

      <div class="box-3">
        <div class="sub-title">多重防护，为企业数据安全保驾护航</div>
      </div>

      <div class="box-6"></div>

  </div>
</template>
<script>
import * as api from "../api"
import Swiper from 'swiper'
import css from 'swiper/css/swiper.min.css'
export default {
   data () {
       return {
         box2List:[
           {
             title:"钉钉专业版",
             text:"满足中小企业数字化升级需求，打造灵活开发的数字化生产力平台",
             video: require('./img-12-30/video1.mp4'),
             videoImg:require('./img-12-30/videoimg1.jpg'),
             url:"major",
             classN:'active0',
             active:true,
             activeBg: require('./img-12-30/active1.png') // 按钮激活背景：webp格式
           },
           {
             title:"钉钉专属版",
             text:"面向企业的数字化安全底座，提供混合云部署、安全合规、自主可控和专属AI，打造专属数字化平台",
             video: require('./img-12-30/video2.mp4'),
             videoImg:require('./img-12-30/videoimg2.jpg'),
             url:"onlyDingding",
             classN:'active1',
             active:false,
             activeBg: require('./img-12-30/active1.png') // 按钮激活背景：webp格式
           },
           {
             title:"Teambition（项目管理）",
             text:"将企业战略目标和企业项目转化为明确可执行的项目和任务，跨越从战略到执行的鸿沟，助力企业实现上下同欲、左右协同、使命必达",
             video: require('./img-12-30/video3.mp4'),
             videoImg:require('./img-12-30/videoimg3.png'),
             url:"teamB",
             classN:'active2',
             active:false,
             activeBg: require('./img-12-30/active1.png') // 按钮激活背景：webp格式
           },
           {
             title:"钉钉管理套件",
             text:"打造人事、财务、差旅、营销服、合同等一站式管理套件产品，助力企业经营管理数字化升级",
             video: require('./img-12-30/video4.mp4'),
             videoImg:require('./img-12-30/videoimg4.jpg'),
             url:"qita",
             classN:'active3',
             active:false,
             activeBg: require('./img-12-30/active1.png') // 按钮激活背景：webp格式
           },
         ],
         currentVideoSrc: '',
         activeModal:0,

         box4List:[
           {
             title:"氚云应用搭建，智能化全面升级",
             text1:"可视化拖拽设计，一搭就行",
             text2:"丰富的专属定制能力",
             text3:"AI驱动利旧，企业即有系统焕发新生力",
             img: require('./img-12-30/box4-img1.png'),
             url:"chuanyun",
             classN:'active0',
             classN2:'btn0',
             active:true,
             normalBg: require('./img-12-30/box4-normal0.png'),
             activeBg: require('./img-12-30/box4-active0.png')
           },
           {
             title:"魔法棒·Al生产力平台",
             text1:"开箱即用的钉钉AI产品，让企业零成本切入AI",
             text2:"企业自建，企业客户按照个性化的需求自行搭建AI应用",
             text3:"提供面向中大型组织深度定制的AI专属能力",
             img: require('./img-12-30/box4-img2.png'),
             url:"qita",
             classN:'active1',
             classN2:'btn1',
             active:false,
             normalBg: require('./img-12-30/box4-normal1.png'),
             activeBg: require('./img-12-30/box4-active1.png')
           },
           {
             title:"企业数字资产一键迁移",
             text1:"多种平台均可迁入钉钉，更便捷",
             text2:"数字资产一键迁移，更高效",
             text3:"专业服务团队，为企业迁移提供量身服务，迁移过程更稳定流",
             img: require('./img-12-30/box4-img3.png'),
             url:"qita",
             classN:'active2',
             classN2:'btn2',
             active:false,
             normalBg: require('./img-12-30/box4-normal2.png'),
             activeBg: require('./img-12-30/box4-active2.png')
           },
         ],
         activeModal4:0,

         box5LeftBg: require('./img-12-30/icon2.webp'),
         mySwiper: null,
           activeIndex: "1",
           image: [
             {image: require("./img-12-30/banner1.png")},
             {image: require("./img-12-30/banner2.png")}
           ],
           controls1:false,
           controls2:false,
           controls3:false,
           controls4:false,
           newsList1:[
            require('./img-12-30/box9-01.png'),
             require('./img-12-30/box9-02.png'),
             require('./img-12-30/box9-03.png'),
             require('./img-12-30/box9-04.png'),
             require('./img-12-30/box9-05.png'),
             require('./img-12-30/box9-06.png'),
             require('./img-12-30/box9-07.png'),
             require('./img-12-30/box9-08.png'),
             require('./img-12-30/box9-09.png'),
             require('./img-12-30/box9-10.png'),
             require('./img-12-30/box9-11.png'),
             require('./img-12-30/box9-12.png'),
           ],
           newsList2:[
             require('./img-12-30/box9-13.png'),
             require('./img-12-30/box9-14.png'),
             require('./img-12-30/box9-15.png'),
             require('./img-12-30/box9-16.png'),
             require('./img-12-30/box9-17.png'),
             require('./img-12-30/box9-18.png'),
             require('./img-12-30/box9-19.png'),
             require('./img-12-30/box9-20.png'),
             require('./img-12-30/box9-21.png'),
             require('./img-12-30/box9-22.png'),
             require('./img-12-30/box9-23.png'),
             require('./img-12-30/box9-24.png'),

           ],

           dataListCase: [],

           gongsibiaozhiList:[
             {
               imgUrl:require('../assets/img-07-03/img-icon-chanpin2-tuya.webp'),
               text:'钉钉六星级服务商'
             },
              {
                imgUrl:require('../assets/img-07-03/img-icon-chanpin1-tuya.png'),
                text:'钉钉金牌部署服务商'
              },
              {
                imgUrl:require('../assets/img-07-03/img-icon-chanpin3-tuya.png'),
                text:'专属钉钉核心代理商'
              },
              {
                imgUrl:require('../assets/img-07-03/img-icon-chanpin4-tuya.webp'),
                text:'数字区县核心代理商'
              },
              {
                imgUrl:require('../assets/img-07-03/img-icon-chanpin5-tuya.png'),
                text:'政企高级服务企业'
              },
              {
                imgUrl:require('./imgs/img-tb-tuya.png'),
                text:'Teambition核心代理商'
              },

           ],

           chanpinList:[
              {text:'钉钉专业版',info:'打造属于企业自己的数字化资产',path:'major'},
              {text:'钉钉专属版',info:'定义企业自己的数字化工作学习方式',path:'onlyDingding'},
              {text:'项目(Teambition)',info:'为企业提供项目管理、任务协同等解决方案',path:'teamB'},
           ],
           chanpinList2:[
              {text:'氚云',info:'更专业的功能 / 更智能的搭建',imgUrl:require('./img-bg-color/img-bg-color-s1.jpg'),path:'chuanyun'},
              {text:'云枢',info:'企业专属、安全、开放的数字化办公',imgUrl:require('./img-bg-color/img-bg-color-s2.jpg'),path:'yunshu'},
              {text:'宜搭',info:'助力生产力创新、加速企业数字化转型',imgUrl:require('./img-bg-color/img-bg-color-s3.jpg'),path:'yida'},
           ],
           jiejuefangan:[
              {text:'工程管理',info1:'利用数字化技术',info2:'建立规范的管理标准',imgUrl:'http://img601.yun300.cn/repository/image/014f669c-a150-4f93-9e43-8e21907dfd21.png?tenantId=214689&viewType=1&k=1651226704000',path:'engineeringManagement'},
              {text:'云端办公室',info1:'远程协助',info2:'高效办公',imgUrl:'http://img601.yun300.cn/repository/image/98430932-6d47-4b57-a590-9c90f404cad9.png?tenantId=214689&viewType=1&k=1651226704000',path:'OACloud'},
              {text:'视频会议',info1:'高清视频会议',info2:'最高支持302人同时在线',imgUrl:'http://img601.yun300.cn/repository/image/f6641615-e861-4699-bd78-1b404c45c00e.png?tenantId=214689&viewType=1&k=1651226704000',path:'videoconferencing'},
              {text:'高级工作台',info1:'轻量级+适配型',info2:'助力企业数字化升级',imgUrl:'http://img601.yun300.cn/repository/image/6f426741-6a88-4473-987b-3693b72561b2.png?tenantId=214689&viewType=1&k=1651226704000',path:'highWork'},
           ],
           dingdingzhilianList:[
            {text:'智能考勤',imgUrl:require('./img-bg-color/img-yingjian-s2.jpg')},
            {text:'智能门禁',imgUrl:require('./img-bg-color/img-yingjian-s3.jpg')},
            {text:'智能打印',imgUrl:require('./img-bg-color/img-yingjian-s4.jpg')},
            {text:'视频会议',imgUrl:require('./img-bg-color/img-yingjian-s5.jpg')},
           ],
         personImg:[
           require('./imgs/person-img2/person1.svg'),
           require('./imgs/person-img2/person2.svg'),
           require('./imgs/person-img2/person3.svg'),
           require('./imgs/person-img2/person4.svg'),
         ],
         lbImgSrc:require('./img-12-30/lb2.png'),
         slideList: [
           {
             imgUrl: require('./img-12-30/box7-1.png'),
             imgUrl2: require('./img-12-30/box7-1-1.png'),
             title: '产业链',
             desc: '立体网状的新一代产业互联平台'
           },
           {
             imgUrl: require('./img-12-30/box7-2.png'),
             imgUrl2: require('./img-12-30/box7-2-2.png'),
             title: '互联网',
             desc: '构建灵活立体敏捷组织，打造智能互联生产模式'
           },
           {
             imgUrl: require('./img-12-30/box7-3.png'),
             imgUrl2: require('./img-12-30/box7-3-3.png'),
             title: '高校行业',
             desc: '钉钉助力高校推进数字化改革实践'
           },
           {
             imgUrl: require('./img-12-30/box7-4.png'),
             imgUrl2: require('./img-12-30/box7-4-4.png'),
             title: '金融行业',
             desc: '助力金融机构数字化，组织变革与业务创新'
           },
           {
             imgUrl: require('./img-12-30/box7-5.png'),
             imgUrl2: require('./img-12-30/box7-5-5.png'),
             title: '政府',
             desc: '助力政府打造数智化-网协同体系'
           },
           {
             imgUrl: require('./img-12-30/box7-6.png'),
             imgUrl2: require('./img-12-30/box7-6-6.png'),
             title: '零售行业',
             desc: '用数字化能力助力零售业务效能提升'
           },
           {
             imgUrl: require('./img-12-30/box7-7.png'),
             imgUrl2: require('./img-12-30/box7-7-7.png'),
             title: '医疗行业',
             desc: '基于数字底座的医院智慧管理解决方案'
           }, {
             imgUrl: require('./img-12-30/box7-8.png'),
             imgUrl2: require('./img-12-30/box7-8-8.png'),
             title: '制造行业',
             desc: '基于产品融合能力打造生产业务流程一体化'
           },
           {
             imgUrl: require('./img-12-30/box7-9.png'),
             imgUrl2: require('./img-12-30/box7-9-9.png'),
             title: '交通行业',
             desc: '打造交通行业全链路数字化解决方案'
           },
           {
             imgUrl: require('./img-12-30/box7-10.png'),
             imgUrl2: require('./img-12-30/box7-10-10.png'),
             title: '更多行业',
             desc: '在线咨询：获取专属行业定制方案'
           },
           // 依次添加其他轮播项数据
         ],
         isHovered: [], // 用于存储每个轮播项的鼠标悬停状态
         box8:[
           require('./img-12-30/box8-1.png'),
           require('./img-12-30/box8-2.png'),
           require('./img-12-30/box8-3.png'),
         ],
         currentIndex: 0,
         slideWidth: 0,
         box10Img:require('./img-12-30/box-10-2.png')
       }
   },
  mounted () {
    this.initSwiper()
    this.slideWidth = this.$refs.carouselWrapper.firstElementChild.offsetWidth +  20;
    // 初始化 isHovered 数组，默认所有项为 false
    this.slideList.forEach(() => {
      this.isHovered.push(false);
    });
    // this.startAutoPlay();
    // 客户案例
    //   api.getLunboApi(0).then(res=>{
    //     console.log(res.data,"ccc");
    //     this.image = res.data.data
    //   })
      api.getDataApi(5,1,4).then(res=>{
        console.log(res.data,"aaa");
        this.dataListCase = res.data.list
      })
    // setInterval(()=>{
    //   if(this.activeModal == 3) {
    //     this.activeModal = 0
    //   } else {
    //     this.activeModal += 1
    //   }
    //   this.box2List.map((item)=>item.active = false)
    //   this.box2List[this.activeModal].active = true
    // },5000)
   },
   methods: {
     handleMouseEnter(index) {
       this.$set(this.isHovered, index, true);
     },
     handleMouseLeave(index) {
       this.$set(this.isHovered, index, false);
     },
     handleBtn(index){
       this.activeModal = index
       this.box2List.map((item)=>item.active = false)
       this.box2List[index].active = true

       const videoSource = document.getElementById('videoSource');
       videoSource.src = this.box2List[index].video
       const video = document.getElementById('videoBox');
       video.load();// 重新加载视频
       // video.play();// 播放视频

     },
     handleBtn4(index){
       this.activeModal4 = index
       this.box4List.map((item)=>item.active = false)
       this.box4List[index].active = true
     },
    /**
      * 人物简介轮播图
      */
   initSwiper(){
     this.mySwiper = new Swiper('.swiper', {
       slidesPerView: 4,
       spaceBetween: 30,
       centeredSlides: false,
       loop:false,
       direction: 'horizontal', // 水平方向
       speed: 500, // 切换速度
       autoplay: {
         delay: 3000, // 自动切换间隔时间
         disableOnInteraction: true // 用户操作后是否停止自动切换
       },
       navigation: {
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev'
       },
     });
     //鼠标移入停止播放，鼠标离开  继续轮播
     this.mySwiper.el.onmouseover=()=>{
       this.mySwiper.autoplay.stop();
     }
     this.mySwiper.el.onmouseleave=()=>{
       this.mySwiper.autoplay.start();
     }
   },

    clickJumpCase(item){// 客户案例
      console.log(item);
      window.open(`${item.jumpUrl}`)
    },
    clickJumpLunbo(){
      // console.log(item);
      // if(item.imageUrl.indexOf('http') > -1){
          // window.open(`${item.imageUrl}`)
        window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
      // }else{
      //   this.$router.push({name:`${item.imageUrl}`})
      // }
    },
     jumpspart(name){
       if(name !== 'qita'){
         this.$router.push({name:name})
       } else {
         window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
       }
     },
    clickControls1(){
      this.controls1 = true
      // 点击时才播放视频，减少初始加载压力
      // document.getElementById('videoBox').play()
    },
     clickJumpDiangFlash(item){
       this.$router.push({name:item.path})
     },
     chanpinhanler(item){
        this.$router.push({name:item.path})
     },
     clickMore1(){
        this.$router.push({name:'solution'})
     },
     clickmore2(){
        this.$router.push({name:'dingConnect'})
     },
     clickmore3(){
        this.$router.push({name:'customerCase'})
     },
     clickmore4(){
        this.$router.push({name:'aboutUs'})
     },
     clickjiejuefangan(item){
        this.$router.push({name:item.path})
     },

     jumpFuwu(){
       this.$router.push({name:"solution"})
     },
     jumpGongchengguanli(){
       //跳转到工程管理
       this.$router.push({name:"engineeringManagement"})
     },
      jumpShuzuGongchang(){
        //跳转到数字工厂
        this.$router.push({name:"digitalFactory"})
      },
      jumpZhihuiXiaofang(){
        //跳转到智慧消防
        this.$router.push({name:"videoconferencing"})
      },
      jumpYuanZichan(){
        //跳转到原资产
        this.$router.push({name:"highWork"})
      },
      jumpMorFangan(){
        //跳转到解决方案
        this.$router.push({name:"solution"})
      },
      jumpDIngZhilian(){
        //跳转到顶顶智联
        this.$router.push({name:"dingConnect"})
      },
      jumpMoreAnli(){
        //跳转到客户案例
        this.$router.push({name:"customerCase"})
      },
      jumpAboutus(){
        //跳转到关于我们
        this.$router.push({name:"aboutUs"})
      },
      jumpMoreRenmenHuodong(){
        //跳转到热门活动
        this.$router.push({name:"popularActivities"})
      },



      // 客户案例
      jumpJYZF(){
        this.$router.push({name:"jianyezhengfu"})
      },

     clickSM(){
       window.open('https://isite.baidu.com/site/wjzkc6f4/1d54fdc4-8357-4b68-ba04-d6ba1a1951d6')
     },

     jumpcustomerCase(){
       this.$router.push({name:"customerCase"})
     }
   },
   computed: {
                optionLeft1 () {
                    return {
                            direction: 2,
                            step:1,
                            limitMoveNum: 8,
                            hoverStop:false,
                        }
                },
                optionLeft2 () {
                    return {
                            direction: 2,
                            step:1,
                            limitMoveNum: 8,
                            hoverStop:false,
                        }
                },
             }
}
</script>
<style lang='less' scoped>
.all-box{
    .lunbo-box{
      width: 100%;
      height: 798px;
      margin: 0 auto;
      .el-carousel {
        width: 100%;
        height: 100%;
        /deep/ .el-carousel__container {
          height: 100%!important;
        }
        .el-carousel__item {
            height: 100%;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: opacity 0.3s;
            }
        }
        .el-carousel__item:nth-child(2n) {
          background-color: #99a9bf;
        }
        .el-carousel__item:nth-child(2n + 1) {
          background-color: #d3dce6;
        }
      }
    }

    .box-1 {
      width: 100%;
      height: 280px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .box-2 {
      width: 100%;
      .top-box{
        height: 260px;
        width: 100%;
        padding: 46px 224px 0 224px;
        display: flex;
        justify-content: space-around;
        .btn-box{
          width: 426px;
          height: 212px;
        }
        .btn {
          width: 426px;
          height: 212px;
          line-height: 22rem;
          font-size: 24px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
        }
        .active0{
          width: 426px;
          height: 212px;
          background-size: 100% 100%;
          //background-image: url("./img-12-30/active1.png");
        }
        .active1{
          width: 426px;
          height: 212px;
          background-size: 100% 100%;
          //background-image: url("./img-12-30/active2.png");
        }
        .active2{
          width: 426px;
          height: 212px;
          background-size: 100% 100%;
          //background-image: url("./img-12-30/active3.png");
        }
        .active3{
          width: 426px;
          height: 212px;
          background-size: 100% 100%;
          //background-image: url("./img-12-30/active4.png");
        }
      }
      .bottom-box{
        width: 100%;
        height: 798px;
        background-size: 100% 100%;
        background-image: url("./img-12-30/bg1.png");
        position: relative;
        .left-box{
          //padding: 10px;
          width: 1064px;
          height: 300px;
          position: absolute;
          left: 11%;
          top:30%;
          font-size: 24px;
          .title{
            font-size: 38px;
            font-weight: 500;
            margin-bottom: 26.6px;
            text-align: left;
          }
          .text{
            font-size: 24px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            text-align: left;
          }
          .btn1{
            width: 212px;
            height: 66px;
            line-height: 66px;
            border-radius: 6px;
            background: rgba(0, 137, 255, 1);
            color: rgba(255, 255, 255, 1);
            margin: 80px 40px 0 0;
            cursor: pointer;

          }
          .btn2{
            width: 212px;
            height: 66px;
            line-height: 66px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            border: 2px solid rgba(0, 137, 255, 1);
            color: rgba(0, 137, 255, 1);
            margin: 80px 40px 0 0;
            cursor: pointer;
          }
        }
      }
    }

    .box-3 {
      width: 100%;
      height: 340px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 26px;
    }
    .box-3-1 {
      width: 100%;
      height: 250px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 26px;
    }

    .box-4{
      width: 100%;
      .top-box{
        height: 10rem;
        width: 100%;
        padding: 35px 450px 0 450px;
        display: flex;
        justify-content: space-around;
        .btn-box{
          width: 23rem;
          height: 10rem;
        }
        .btn0,.btn1,.btn2{
          margin-top: 36px;
          width: 23rem;
          height: 7.8rem;
          background-size: 100% 100%;
        }
        .active0,.active1,.active2{
          width: 23rem;
          height: 10rem;
          background-size: 100% 100%;
        }
      }
      .bottom-box{
        width: 100%;
        height: 800px;
        background-size: 100% 100%;
        background-image: url("./img-12-30/bg2.webp");
        position: relative;
        .left-box{
          //padding: 10px;
          width: 800px;
          height: 25rem;
          position: absolute;
          left: 11%;
          top:25%;
          .title{
            font-size: 38px;
            font-weight: 500;
            margin-bottom: 20px;
            text-align: left;
          }
          .text{
            font-size: 24px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            text-align: left;
            margin: 20px 0;
          }
          .text::before {
            content: url('./img-12-30/icon.png');
            display: inline - block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 15px;
          }
          .btn1{
            width: 212px;
            height: 66px;
            font-size: 24px;
            line-height: 66px;
            border-radius: 6px;
            background: rgba(0, 137, 255, 1);
            color: rgba(255, 255, 255, 1);
            margin: 80px 40px 0 0;
            cursor: pointer;

          }
          .btn2{
            width: 212px;
            height: 66px;
            font-size: 24px;
            line-height: 66px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            border: 2px solid rgba(0, 137, 255, 1);
            color: rgba(0, 137, 255, 1);
            margin: 80px 40px 0 0;
            cursor: pointer;
          }
        }
      }
    }

    .box-5{
      width: 100%;
      height: 611.8px;
      display: flex;
      justify-content:center;
      align-items: center;

      .left-box{
        width: 33.33rem;
        height: 33.33rem;
        background-size: 100% 100%;
      }
      .left-box img{
        width: 100%;
        height: auto;
      }
      .carousel-container {
        width: 1580px;
        overflow: hidden;
      }
      .carousel-wrapper {
        display: flex;
        width: 5876px; /* 图片实际宽度 */
        animation: scroll 25s linear infinite; /* 动画名称、时长、速度曲线、循环次数 */
      }
      .carousel-wrapper img {
        width: 100%;
        height: auto;
      }
      @keyframes scroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-4296px); /* 图片宽度 - 容器宽度，即5876px - 1580px */
        }
      }
      }

    .box-6{
      width: 100%;
      height: 76.6rem;
      background-size: 100% 100%;
      background-image: url("./img-12-30/fenzu56.png");
    }

    .box-10 {
      width: 85%;
      height: 60rem;
      margin: 0 auto;
      background-size: 100% 100%;
      background-image: url("./img-12-30/box-10.png");
      position: relative;
      .title-box {
        position: absolute;
        left: 5%;
        top:22%;
        .title{
          text-align: left;
          font-weight: 500;
          letter-spacing: 2px;
          font-size: 2.32rem;

        }
      }

      .box-10Img {
        width: 44rem;
        height: auto;
        position: absolute;
        left: 5%;
        top: 42%;
      }
      .btn1{
        width: 212px;
        height: 66px;
        line-height: 66px;
        border-radius: 6px;
        background: rgba(0, 137, 255, 1);
        color: rgba(255, 255, 255, 1);
        margin: 80px 40px 0 0;
        cursor: pointer;
      }
      .btn2{
        width: 260px;
        height: 66px;
        line-height: 66px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(0, 137, 255, 1);
        color: rgba(0, 137, 255, 1);
        margin: 80px 40px 0 0;
        cursor: pointer;
      }
      .btn-flex {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 24px;
        position: absolute;
        left: 5%;
        bottom: 23%;
      }
    }

    .box-7{
      width: 100%;
      display: flex;
      justify-content: center;
      .carousel-container{
        width: 133rem;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
      }
      .carousel-wrapper {
        margin: 2rem;
        display: flex;
      }
      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-100%);
        width: 4.8rem;
        height: 4.8rem;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 2px solid rgba(42, 130, 228, 1);
        color: rgba(42, 130, 228, 1);
        font-size: 2rem;
      }
      .swiper-button-prev {
        left: 2rem;
      }
      .swiper-button-next {
        right: 2rem;
      }
      .slide-item {
        width: 25rem; /* 假设每个轮播项的最小宽度 */
        height: 42rem;
        text-align: center;
        //margin: 1rem;
        border-radius: 1rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 25px  rgba(0, 0, 0, 0.15);
      }
      .img-css {
        width: 100%;
        height:24rem;
        border-radius: 1rem 1rem 0 0;

      }
      .title {
        font-size: 2rem;
        font-weight: 500;
        letter-spacing: 1px;
        margin-top: 2rem;
      }
      .sub-title{
        font-size: 1.4rem;
        font-weight: 500;
        letter-spacing: 1px;
        margin: 1rem 0 2rem 0;
        padding: 0 3rem;
      }
      .link{
        font-size: 1.4rem;
        letter-spacing: 1px;
        color: rgba(0, 137, 255, 1);
        cursor: pointer;
      }
    }

    .box-8 {
      //margin: 0 14rem;
      img{
        width: 41.25rem;
        height: auto;
        margin: 3rem;
        cursor: pointer;
      }
    }

  .box-9 {
    width: 100%;
    margin:0 auto;
    box-sizing: border-box;
    background-color: rgba(235, 243, 250, 1);
    .cneter-hot{
      width: 85%;
      margin: 0 auto;
    }
    .main-hot{
      width: 100%;
      height: 34.91rem;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .seamless-warp2{
        width: 100%;
        height: 11.6rem;
        overflow: hidden;
        position: relative;
        margin-bottom: 20px;
        .item{
          width: auto;
          li {
            width: 23rem;
            height: 11.6rem;
            float: left;
            margin-right: 20px;
            background-color: #fff;
            border-radius: 10px;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
            }

          }
        }
      }
      //.seamless-warp2::before{
      //  background-image: -webkit-linear-gradient(left,#ebedf0 20%,rgba(235,237,240,0));
      //  content: "";
      //  height: 120%;
      //  left: -15px;
      //  position: absolute;
      //  top: -10px;
      //  width: 100px;
      //  z-index: 2;
      //}
      //.seamless-warp2::after{
      //  background-image: -webkit-linear-gradient(right,#ebedf0 20%,rgba(235,237,240,0));
      //  content: "";
      //  height: 120%;
      //  position: absolute;
      //  right: -15px;
      //  top: -10px;
      //  width: 100px;
      //  z-index: 2;
      //}

    }
  }

  //.box-10{
  //  height: 62rem;
  //  background: linear-gradient(180deg, rgba(235, 244, 255, 1) 0%, rgba(245, 251, 255, 0.5) 100%);
  //}


    // 公共
    .flex {
      display: flex;
    }

  .margin-t{
    margin-top: 60px;
  }

    .sub-title{
      font-size: 80px;
      font-weight: 500;
      letter-spacing: 2px;
      color: rgba(0, 0, 0, 1);
    }
    .title-txt{
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.6);
      margin-top: 20px;
    }



    .common-text-big{
      width: 100%;
      padding: 30px;
      color: #000;
      font-size: 48px;
      background-color: #fff;
      letter-spacing: 3px;
      margin-top: 55px;
    }

    .common-text-lettle{
      width: 100%;
      padding: 30px;
      padding-top: 5px;
      color: rgb(105, 105, 105);
      font-size: 26px;
      background-color: #fff;
      letter-spacing: 1.5px;
    }
    .biaoti-teshus1{
      margin: 0px;
      background-color: #ebedf0;
      padding-top: 100px;
    }
    .biaoti-teshus2{
      background-color: #ebedf0;
    }
    .no-color{
      background-color: transparent;
      color: #fff;
    }
    .no-color1{
      padding-top: 65px;
    }
    .commom-box-padd{
        width: 100%;
        padding: 0px 100px;
        padding-top: 30px;
        padding-bottom: 20px;
    }
    .common-box-ul{
        width: 100%;
        padding: 0px 100px;
        padding-top: 30px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .common-box-ul-lis{
            width: 15%;
            height: 100%;
            background-color: #f5f5f5;
            border-radius: 10px;
            padding: 35px;
            .img-gongsibiaozhi{
                width: 80px;
                height: 80px;
            }
            p{
              font-size: 24px;
              color: #2c3e50;
              letter-spacing: 1.4px;
              margin-top: 20px;
            }
        }
        .common-box-ul-lis2{
            width: 23%;
            height: 100%;
            background-color: #5389fd;
            border-radius: 10px;
            padding: 35px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p-text{
                font-size: 28px;
                color: #fff;
                letter-spacing: 2px;
                margin-top: 10px;
            }
            .line{
              width: 100px;
              height: 1px;
              background-color: #fff;
              margin-top: 20px;
              margin-bottom: 10px;
            }
            .p-info{
              font-size: 22px;
              letter-spacing: 1.5px;
              color: #fff;
              margin-top: 17px;
            }
            .img-jiejuefangan{
                width: 80px;
                height: 80px;
            }
            .btn-box{
              padding:12px 40px;
              margin-top: 38px;
              border: 1px solid #fff;
              border-radius: 8px;
              font-size: 18px;
              color: #fff;
              letter-spacing: 1px;
              cursor: pointer;
              transition: all 0.2s linear;
            }
            .btn-box:hover{
                color: #5389fd;
                background-color: #fff;
            }
            .img-dingdingzhilian{
              width: 100%;
              height: 300px;
              border-radius: 14px;
            }
            .img-anli{
              width: 100%;
              height: 260px;
              border-radius: 14px 14px 0px 0px;
            }
            .p-text-s2{
              margin-top: 60px;
              color: #2c3e50;
              font-size: 28px;
              letter-spacing: 2px;
              margin-bottom: 30px;
            }
        }
        .common-box-ul-lis2ss{
          width: 30%;
        }
        .common-box-ul-lis3{
          width: 30%;
          cursor: pointer;
          transition: all 0.2s linear;
          .p-info,.p-text{
            color: #2c3e50;
          }
          .p-info{
            margin-bottom: 20px;
          }
          .line{
            background-color: #2c3e50;
          }
        }
        .common-box-ul-lis3:nth-child(1){
          background-image: url('http://static601.yun300.cn/repository/image/cde6acf7-e99c-43c0-9d91-8dba01a71d59.jpg?tenantId=214689&v=1651226704000&viewType=1');
        }
        .common-box-ul-lis3:nth-child(2){
          background-image: url('http://static601.yun300.cn/repository/image/325f7ff7-0bc6-4e17-9b53-aaea10e3bda7.jpg?tenantId=214689&v=1651226704000&viewType=1');
        }
        .common-box-ul-lis3:nth-child(3){
          background-image: url('http://static601.yun300.cn/repository/image/73199261-515e-417f-8ed3-96e5e3f50bb0.jpg?tenantId=214689&v=1651226704000&viewType=1');
        }
        .common-box-ul-lis3:hover{
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        }
        .common-box-ul-lis4{
           width: 33%;
           cursor: pointer;
           background-color: transparent;
          .p-s1{
              color: grey;
          }
          .p-s2{
              color: #2c3e50;
              font-size: 30px;
              margin-bottom: 20px;
          }
        }
        .common-box-ul-lis5{
          width: 20%;
          background-color: #f4f9ff;
          .p-text{
            color: #2c3e50;
            font-size: 28px;
            margin-top: 15px;
            margin-bottom: 10px;
          }
          .p-info{
            margin-top: 5px;
            color: grey;
            font-size: 20px;
          }
          .btn-box{
              background-color: #fff;
              color: #0089ff;
              border: 1px solid #0089ff;
              transition: all 0.2s linear;
              cursor: pointer;
          }
          .btn-box:hover{
              color: #fff;
              background-color: #0089ff;
          }
        }
        .common-box-ul-lis6{
          background-color: transparent;
        }
        .common-box-ul-lis7{
          background-color: #f4f9ff;
          padding: 0px;
          .anli-title{
            width: 100%;
            font-size: 25px;
            color: #2c3e50;
            white-space: nowrap; //禁止换行
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 20px;
            margin-bottom: 10px;
            text-align: left;
            padding: 0px 15px;

          }
          .anli-info{
              width: 100%;
              font-size: 20px;
              color: grey;
              white-space: nowrap; //禁止换行
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 15px;
              margin-bottom: 15px;
              text-align: left;
              padding: 0px 15px;
              margin-top: 0px;
          }
          .anli-detil{
            width: 100%;
            text-align: right;
            font-size: 18px;
            cursor: pointer;
            color: #0089ff;
            margin-top: 15px;
            position: relative;
            margin-top: 10px;
            margin-bottom: 15px;
            padding: 0px 15px;
            padding-bottom: 10px;
          }
        }
    }
    .big-video {
        width: 100%;
        height: 920px;
        border-radius: 20px;
        margin: 0 auto;
        padding-left: 300px;
        padding-right: 300px;
    }
    .common-btn-box{
        width: 100%;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        .btn-main{
          padding: 17px 40px;
          font-size: 22px;
          letter-spacing: 2px;
          border-radius: 6px;
          background-color: #fff;
          color: #0089ff;
          border: 1px solid #0089ff;
          transition: all 0.2s linear;
          cursor: pointer;
        }
        .btn-main:hover{
          color: #fff;
          background-color: #0089ff;
        }
    }
    .btn-teshu{
        padding-top: 30px;
        padding-bottom: 60px;
        .btn-main{
            color: #fff;
          background-color: transparent;
          border-color: #fff;
        }
        .btn-main:hover{
            background-color: #fff;
            color: #0089ff;
        }
    }
    .img-zhilian-center{
      width: 50%;
      height: 460px;
      margin: 40px auto;
      margin-top: 60px;
    }
    .adout-us{
      width: 100%;
      // height: 640px;
      background: url("./img-bg-color/img-bg-anout-s.jpg") no-repeat;
      background-size: 100% 100%;
      margin-top: 80px;
      .about-main{
        width: 100%;
        height: 100%;
        background: radial-gradient(circle at 50% 50%,rgba(0,0,0,.27),rgba(0,0,0,.94));
        .p-info-text{
          width: 60%;
          margin: 0 auto;
          text-align: left;
          color: #fff;
          font-size: 22px;
          letter-spacing: 2.5px;
          line-height: 45px;
          margin-top: 20px;
        }
      }
    }

}

</style>
<style lang='less' >
.el-carousel__arrow{
  margin-left: 5rem;
  width: 6rem;
  height: 6rem;
  font-size: 4rem;
}
.el-carousel__arrow--right{
  margin-right: 5rem;
}
</style>

